import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';

const styles = {
  categoryName: {
    font: {
      size: '1.6rem',
      lineHeight: '2.4rem',
      weight: 500,
    },
    color: colors.neutral[900],
    margin: [0],
    marginBottom: '0.4rem',
    textTransform: 'uppercase',
  },
  categoryWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    color: colors.neutral[700],
    borderBottom: '0.1rem solid #C1C7CD',
    marginBottom: '2.4rem',
  },
  editContactInfo: {
    marginRight: '-3rem',
  },
  textInfo: {
    padding: '1.6rem 2.4rem',
    backgroundColor: colors.neutral[100],
    font: { size: '1.4rem', lineHeight: '2rem', weight: 400 },
    letterSpacing: '0.02rem',
    color: colors.neutral[700],
    margin: { top: '2rem', bottom: '4rem' },
    borderRadius: '10px',
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
